import { EventSourcePolyfill } from 'event-source-polyfill';

// Cliente SSE para la narración del progreso de los cambios masivos "progresivos" (updatemany por
// lotes). El canal es POR USUARIO en el backend, así que da igual desde la URL de qué tabla se
// suscriba: cada quien recibe solo el progreso de su propio cambio masivo.
//
// Singleton de módulo: la conexión sobrevive a la navegación. Un usuario solo tiene un cambio
// masivo en curso a la vez, así que una sola conexión basta.

const subscribers = [];
let eventSource = null;
let conectado = false;
let readyCallbacks = [];

function readToken() {
    try {
        const session = JSON.parse(localStorage.getItem('session') || '{}');
        return session.access_token || session.token || session.accessToken || '';
    } catch (e) {
        return '';
    }
}

// Construye la URL del stream a partir del adapter de la tabla (server + prefix + model).
function buildUrl(adapter) {
    return adapter.server_movilidad + adapter.prefix + adapter.model + '/updatemany/events';
}

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('CambioMasivoEvents subscriber threw', err); }
    });
}

function onEvento(event) {
    let payload = null;
    try { payload = JSON.parse(event.data); } catch (err) { payload = event.data; }
    notify(payload);
}

function marcarConectado() {
    conectado = true;
    const cbs = readyCallbacks;
    readyCallbacks = [];
    cbs.forEach(function (cb) { try { cb(); } catch (e) {} });
}

function ensureConnected(adapter) {
    if (eventSource) return;
    const url = buildUrl(adapter);
    eventSource = new EventSourcePolyfill(url, {
        headers: { Authorization: 'Bearer ' + readToken() },
        heartbeatTimeout: 1800000
    });
    // El backend manda un evento "hello" al establecer el canal; onopen es el respaldo. Solo tras
    // esto es seguro lanzar el trabajo: si no, un job pequeño podría emitir "fin" antes de que el
    // stream esté conectado y el front se lo perdería (el canal por-usuario no reenvía el último).
    eventSource.onopen = marcarConectado;
    eventSource.addEventListener('hello', marcarConectado);
    eventSource.addEventListener('cambio-masivo', onEvento);
    eventSource.addEventListener('error', function (err) {
        console.warn('[CambioMasivoEvents] SSE error', err);
    });
}

export default {
    // adapter: el dbAdapter de la tabla (para construir la URL); callback: recibe cada evento;
    // onReady (opcional): se llama cuando el canal está conectado (o ya lo estaba).
    subscribe(adapter, callback, onReady) {
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        if (typeof onReady === 'function') {
            if (conectado) {
                onReady();
            } else {
                readyCallbacks.push(onReady);
            }
        }
        ensureConnected(adapter);
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
        // Sin suscriptores no tiene sentido retener la conexión: en HTTP/1.1 local cada stream SSE
        // consume una de las ~6 conexiones por host.
        if (!subscribers.length) this.close();
    },
    close() {
        if (eventSource) {
            try { eventSource.close(); } catch (e) {}
            eventSource = null;
        }
        conectado = false;
        readyCallbacks = [];
    }
};
